import styled from 'styled-components';

export const Wrapper = styled.div`
	background-color: ${({ theme }) => theme.colors.background.secondary};
	border-radius: 12px;
	gap: 10px;
`;

export const Title = styled.h3`
	font-size: 20px;
	line-height: 27px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.subtitle};
	padding: 16px;

	@media (max-width: 992px) {
		font-size: 14px;
		line-height: 19px;
	}
`;

export const Divider = styled.div`
	width: 100%;
	height: 1px;
	background-color: ${({ theme }) => theme.colors.transparent.light10};
`;

export const Description = styled.p`
	font-size: 16px;
	line-height: 22px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.body};
	padding: 16px;

	@media (max-width: 992px) {
		font-size: 14px;
		line-height: 19px;
	}
`;
